import React, { useEffect, useState } from 'react';

interface ActivityMessage {
  id: number;
  text: string;
  icon: string;
}

const activityMessages: ActivityMessage[] = [
  { id: 1, text: "João Silva acabou de doar em São Paulo", icon: "🔴" },
  { id: 2, text: "Maria precisa de O+ urgente em Curitiba", icon: "🆘" },
  { id: 3, text: "5 doações confirmadas na última hora", icon: "✅" },
  { id: 4, text: "Rafael Costa doou A- no Rio de Janeiro", icon: "🔴" },
  { id: 5, text: "Ana precisa de B+ em Belo Horizonte", icon: "🆘" },
  { id: 6, text: "12 doadores ativos online agora", icon: "🟢" },
  { id: 7, text: "Carlos confirmou doação em Brasília", icon: "✅" },
  { id: 8, text: "Patricia precisa de AB- urgente em Salvador", icon: "🆘" },
  { id: 9, text: "3 vidas salvas hoje em Porto Alegre", icon: "❤️" },
  { id: 10, text: "Lucas doou O- em Fortaleza", icon: "🔴" },
];

export function LiveActivityTicker() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % activityMessages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // Render only double messages for seamless loop (optimized DOM)
  const visibleMessages = [...activityMessages, ...activityMessages];

  return (
    <div className="bg-red-50 border-y border-red-100 overflow-hidden py-3">
      <div className="relative flex">
        <div className="flex animate-marquee whitespace-nowrap">
          {visibleMessages.map((msg, index) => (
            <span
              key={`${msg.id}-${index}`}
              className="mx-8 inline-flex items-center text-sm text-gray-700 font-medium"
            >
              <span className="mr-2">{msg.icon}</span>
              {msg.text}
              <span className="mx-4 text-red-300">•</span>
            </span>
          ))}
        </div>
        <div className="absolute top-0 flex animate-marquee2 whitespace-nowrap" aria-hidden="true">
          {visibleMessages.map((msg, index) => (
            <span
              key={`${msg.id}-${index}-2`}
              className="mx-8 inline-flex items-center text-sm text-gray-700 font-medium"
            >
              <span className="mr-2">{msg.icon}</span>
              {msg.text}
              <span className="mx-4 text-red-300">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
